import { createAction, props } from '@ngrx/store';
import {FilterItem} from '../../filter.model';
import {NodeItem} from '../../node.model';

export const getFilteredProjektStart = createAction('PROJEKTVERWALTUNG::GET_FILTERED_PROJEKTE_START', props<{ string: string, item: FilterItem }>());
export const getFilteredProjektSucceeded = createAction('PROJEKTVERWALTUNG::GET_FILTERED_PROJEKTE_SUCCEEDED', props<{ item: NodeItem[] }>());
export const getFilteredProjektFailed = createAction('PROJEKTVERWALTUNG::GET_FILTERED_PROJEKTE_FAILED', props<{ error: Error }>());
